<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      title="银行卡管理"
      @click-left="goableBack()"
      :z-index="10"></van-nav-bar>
    <div class="page">
      <div class="card-list">
        <template v-if="card_list.length">
          <van-swipe-cell
            class="bank-card"
            v-for="(item, ind) in card_list"
            :key="ind">
            <van-cell>
              <img
                class="bank-card-bgro"
                :src="bank_list[item.bankName].bgro"
                alt="" />
              <div class="bank-card-mian">
                <div class="bank-card-icon">
                  <img :src="bank_list[item.bankName].logo" alt />
                </div>
                <div class="bank-card-info">
                  <div class="bank-card-title">{{ item.bankName }}</div>
                  <div class="bank-card-name">储蓄卡</div>
                  <div class="bank-card-number">
                    **** **** **** {{ item.cardNo }}
                  </div>
                </div>
                <div v-if="item.isDefault" class="tag-safe">安全卡</div>
              </div>
            </van-cell>
            <template v-if="!item.isDefault" slot="right">
              <van-button
                class="btn-safe"
                @click="setSafe(item)"
                text="设为安全卡" />
              <van-button
                class="btn-del"
                type="danger"
                @click="del(item)"
                text="删除" />
            </template>
            <template v-else slot="right">
              <van-button
                class="btn-del"
                type="danger"
                @click="del(item)"
                text="解绑" />
            </template>
          </van-swipe-cell>
          <div class="card-list-placeholder"></div>
        </template>
        <template v-else>
          <div class="van-list__error-text">暂无数据</div>
          <div class="card-list-placeholder"></div>
        </template>
      </div>
      <van-cell class="card-list-footer" @click="$router.push('/bindcard')">
        <div class="card-footer-btn">
          <img class="card-fb-img" src="../../assets/img/bank/u17.png" alt="" />
          <span class="card-fb-txt">添加银行卡</span>
        </div>
      </van-cell>
    </div>
  </div>
</template>

<script>
import * as CustApi from "@/api/cust"
import iconBankList from "./bankList"
import session from "@/utils/session"

import {
  NavBar,
  Toast,
  Dialog,
  PullRefresh,
  Cell,
  CellGroup,
  Button,
  SwipeCell
} from "vant"

export default {
  components: {
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [SwipeCell.name]: SwipeCell,
    [Dialog.Component.name]: Dialog.Component
  },

  data() {
    return {
      refresh: {
        count: 0,
        isLoading: false
      },

      card_list: [],
      bank_list: iconBankList
    }
  },

  created() {
    if (this._confirmLogin({ mustLogin: true })) {
      this.getBindCardList()
    }
  },

  methods: {
    getBindCardList() {
      CustApi.listBindCard()
        .then((data) => {
          this.card_list = data || []
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },
    setSafe(item) {
      Dialog.confirm({
        className: "bl-confirm-dialog",
        message: "是否确认切换安全卡?"
      })
        .then(() => {
          CustApi.editCard(item.id)
            .then((data) => {
              this.getBindCardList()
            })
            .catch((e) => {
              e && Toast(e.msg)
            })
        })
        .catch(() => {})
    },
    del(item) {
      if (item.isDefault) {
        let isExist = false
        for (let i = 0; i < this.card_list.length; i++) {
          const obj = this.card_list[i]
          if (!obj.isDefault) {
            isExist = true
            break
          }
        }
        if (isExist) {
          this.$toast("请先解绑其他银行卡？")
        } else {
          Dialog.confirm({
            className: "bl-confirm-dialog",
            message: item.isDefault
              ? "删除安全卡，可能导致账户无法正常使用，包括但不限于兑付、提现等，您确定要删除吗？"
              : "是否确认解绑银行卡?"
          })
            .then(() => {
              let external = session.get("external")
              CustApi.cancleCard(item.id)
                .then(() => {
                  if (external === "1") {
                    this.card_list = []
                  } else {
                    this.getBindCardList()
                  }
                })
                .catch((e) => {
                  e && Toast(e.msg)
                })
            })
            .catch(() => {})
        }
      } else {
        Dialog.confirm({
          className: "bl-confirm-dialog",
          message: item.isDefault
            ? "删除安全卡，可能导致账户无法正常使用，包括但不限于兑付、提现等，您确定要删除吗？"
            : "是否确认解绑银行卡?"
        })
          .then(() => {
            let external = session.get("external")
            CustApi.cancleCard(item.id)
              .then(() => {
                if (external === "1") {
                  this.card_list = []
                } else {
                  this.getBindCardList()
                }
              })
              .catch((e) => {
                e && Toast(e.msg)
              })
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card-list {
  background-color: #f1f5f8;
  padding: 10px 15px;

  .bank-card {
    border-radius: 5px;
    margin-bottom: 5px;
    background-color: transparent;
    &::after {
      display: none;
    }

    .bank-card-mian {
      font-size: 0;
      background-color: transparent;
      position: relative;
      z-index: 10;
      padding-top: 10px;
      padding-left: 20px;
      padding-bottom: 10px;

      .tag-safe {
        position: absolute;
        top: 0;
        right: 0;
        background: #e8c973;
        color: #a87027;
        font-size: 14px;
        padding: 0 10px;
        font-weight: bold;
      }
    }

    .bank-card-bgro {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      /* height: 100%; */
    }

    .bank-card-icon,
    .bank-card-info {
      display: inline-block;
      vertical-align: top;
    }

    .bank-card-icon {
      position: relative;
      top: 4px;

      img {
        width: 40px;
        height: 40px;
      }
    }

    .bank-card-info {
      margin-left: 20px;
      font-size: 12px;
      color: white;
    }

    .van-cell {
      padding: 0;
      margin-bottom: 5px;
      border-radius: 8px;
    }
    .btn-del {
      height: 100%;
      border-radius: 0;
    }
    .btn-safe {
      height: 100%;
      border-radius: 0;
      background: rgb(202, 121, 120);
      color: #fff;
      border: 1px solid rgb(202, 121, 120);
    }
  }

  &-placeholder {
    height: 20px;
  }

  .van-list__error-text {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }
}

// 添加银行卡
.card-footer-btn {
  background-color: #fff;
  text-align: center;
  font-size: 0;
  padding: 5px 0;

  .card-fb-img {
    width: 26px;
    vertical-align: middle;
  }

  .card-fb-txt {
    font-size: 16px;
    vertical-align: middle;
    margin-left: 14px;
  }
}
</style>
